import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import backdropImage from '../images/two_one_upscaled.webp'

function Overlay({enlargedLinkType, enlargedGifLink, categoryReturn, backgroundPosition}) {
    const navigate = useNavigate()

    const handleClose = () => {
        navigate(`/fireworks/${categoryReturn}`)
    }

    const backgroundStyle = {
        // backgroundImage: `linear-gradient(90deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 20%, rgba(0, 0, 0, 0.5) 90%), url(${backdropImage})`,
        backgroundImage: `linear-gradient(to left, rgba(0, 0, 0, .7) 0%, rgba(0, 0, 0, 0) 20%), 
                          linear-gradient(to right, rgba(0, 0, 0, .7) 0%, rgba(0, 0, 0, 0) 20%), 
                          url(${backdropImage})`,
        backgroundSize: '100% auto',
        backgroundPosition: 'center top',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        height: 'auto',
        minHeight: '100vh',
        width: '100%',
        overflow: 'hidden',
        backgroundPositionY: backgroundPosition,
        backgroundColor: 'black',
      }

    return  <div style={backgroundStyle}>
    
    <div style={styles.modalOverlay} onClick={(e) => handleClose()}>
    <img
      src={enlargedGifLink}
      alt={"url not found"}
      style={
        enlargedLinkType === 'img'
          ? styles.enlargedImg
          : styles.enlargedGif
      }
    />
  </div>
  </div>
}

export default Overlay

const styles = {
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.8)', // Dark overlay
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // zIndex: 1000,
      },
    enlargedImg: {
        zIndex: 99999,
        width: 'auto',
        height: '60%',
        // boxShadow: "0 0 20px rgba(255, 255, 255, 0.5)",
        // borderRadius: "8px",
        // zIndex: 1100,
      },
      enlargedGif: {
        // zIndex: 99999,
        width: window.innerWidth < 768 ? "100%" : "", // ✅ Changes only on mobile
        // width: "100%",
        // height: "auto",
        height: window.innerWidth < 768 ? "auto" : "", // ✅ Changes only on mobile
    
        // boxShadow: "0 0 20px rgba(255, 255, 255, 0.5)",
        // borderRadius: "8px",
        // zIndex: 1100,
    
      //   maxWidth: "90vw",
      // maxHeight: "90vh",
      // width: "auto",
      // height: "auto",
      // objectFit: "contain", // ✅ Ensures entire GIF is visible
      // animation: "none", // ✅ Prevents flickering from repeated CSS animations
      },
}